export default function Unauthorized() {
  return <h1>You are unauthorized to access this page!</h1>;
}
